:host {
  @include reset-host;
}

:host .default-layout {
  overflow: clip;
}
